// router/index.js
import { createRouter, createWebHistory, createMemoryHistory } from 'vue-router'
import { routes } from './routes'

const isServer = typeof window === 'undefined'

let isInitialLoad = true

const router = createRouter({
	history: isServer ? createMemoryHistory() : createWebHistory(),
	routes,
	scrollBehavior(to) {
		if (isInitialLoad) {
			isInitialLoad = false
			// при первой загрузке не скроллим к якорю, остаёмся вверху
			return { top: 0 }
		}

		if (to.hash) {
			return new Promise(resolve => {
				setTimeout(() => {
					const el = document.querySelector(to.hash)
					const header = document.querySelector('header')
					const headerHeight = header ? header.offsetHeight : 0

					if (el) {
						const top = el.getBoundingClientRect().top + window.scrollY - headerHeight - 15
						window.scrollTo({ top, behavior: 'smooth' })
					}

					resolve(false)
				}, 300)
			})
		}

		return { top: 0 }
	},
})

// router.afterEach((to) => {
// 	if (typeof window !== 'undefined' && import.meta.env.VITE_IS_PROD === 'true' && window.ym) {
// 		window.ym(102741984, 'hit', to.fullPath)
// 	}
// })

export { router }
export default router
